import React from 'react';
import Review from './Review';

const Testimonials = () => {
    return (
        <div id='testimoni'>
            <div className='title'>
                <p className='heading3'>Testimonials</p>
                {/* <div className='underline'></div> */}
            </div>
            <main>
                <section className='testimonials'>
                    <Review />
                </section>
            </main>
        </div>
    );
};

export default Testimonials;